/**
 * Example auth api connector that lets your user log in using a defined payload
 * and returns a promise
 */

import api from '@/config/api'
import store from 'store'
import vuex from '@/store'
// import cookies from 'js-cookie'

export default {
  getDockerServices() {
    return api.get('/v2/docker/swarm/services')
  },
  getStationContainers() {
    return api.get('/v2/stagehand/containers/full')
  },
  stopContainer(serviceId) {
    return api.post(`/v2/docker/swarm/services/${serviceId}/stop`)
  },
  startContainer(serviceId) {
    return api.post(`/v2/docker/swarm/services/${serviceId}/start`)
  },
  rebuildImage() {
    let station = vuex.getters.currentStation.station
    return api.post(`/v2/stagehand/pipeline/BUILD_CONTAINER/${station}`)
  },
  deployLatestImage(serviceId, data) {
    return api.post(`/v2/docker/swarm/services/${serviceId}/image`, data)
  },
  updateImageInfo() {
    return api.post(`/v2/stagehand/images`)
  }
}
